import {useEffect, useState} from 'react';

export const AppStore = () => {

    const Strings = data_value_scripts_object;
    const AppStoreObject = data_value_app_store_scripts_object;

    const [filters, setFilters] = useState({
        product: '',
        category: '',
        version: '',
    });
    const [products, setProducts] = useState([]);
    const [productsLoading, setProductsLoading] = useState(true);

    const handleFilterChange = (filterName, value) => {
        setFilters({
            ...filters,
            [filterName]: value,
        });
    };

    useEffect(() => {
        fetch(Strings.wp_ajax_url, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: new URLSearchParams({
                action: "dv_app_store_products_action",
                nonce: AppStoreObject.data_value_app_store_nonce,
            }),
        })
            .then(response => response.json())
            .then((res) => {
                setProductsLoading(false);
                setProducts(res?.data);
            })
            .catch(error => {
                setProductsLoading(false);
                console.error("Error fetching products:", error)
            });
    }, []);

    const filteredItems = Array.isArray(products)
        ? products.filter(item => {
            const categories_ids = item.categories.map(category => category.term_id);
            const versions_ids = item.tags.map(tag => tag.term_id);
            const product_value = new RegExp(filters.product, "i");
            const productMatch = !filters.product || item.name.match(product_value);
            const categoryMatch = !filters.category || (categories_ids.includes(parseInt(filters.category)));
            const versionMatch = !filters.version || (versions_ids.includes(parseInt(filters.version)));
            return productMatch && categoryMatch && versionMatch;
        })
        : [];

    const get_taxonomy = (taxonomy) => {
        if (taxonomy && taxonomy.length) {
            return taxonomy;
        }
        return null;
    }

    const __ = (text = '') => {
        let translated_text = text;
        if (text && data_value_scripts_object[text]) {
            translated_text = data_value_scripts_object[text];
        }
        return translated_text;
    }

    const wp_ajax_url = data_value_scripts_object.wp_ajax_url;


    return (
        <>
            <div className="app-store-header">
                <div className="container">
                    <div className="d-flex align-items-center">
                        <h4>{__('All Applications')}</h4>
                        <div className="app-store-header-form">
                            <input type="search" className="app-store-input" onChange={e => handleFilterChange('product', e.target.value)} value={filters.product} placeholder={__('Find app ...')}/>
                            <select className="app-store-select" onChange={e => handleFilterChange('category', e.target.value)} value={filters.category}>
                                <option value=''>{__('All Categories')}</option>
                                {AppStoreObject.taxonomy_product_categories.map(category => <option value={category.id}>{__(category.name)}</option>)}
                            </select>
                            <select className="app-store-select" onChange={e => handleFilterChange('version', e.target.value)} value={filters.version}>
                                <option value=''>{__('All Versions')}</option>
                                {AppStoreObject.taxonomy_product_tags.map(version => <option value={version.id}>{__(version.name)}</option>)}
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div className="app-store-products">
                <div className="container">
                    <div className="row">
                        {productsLoading && <div className="col-12 text-center">
                            <div className="app-store-products-item-loading"></div>
                        </div>}
                        {filteredItems.length ? filteredItems.map(item => <div className="col-xxl-3 col-xl-4 col-md-6">
                            <div className={`app-store-products-item animate__animated animate__zoomIn animate__faster ${item.on_sale ? 'products-item-sale' : ''}`} data-sale={__('Sale')}>
                                <a href={item.link}>
                                    <img src={item.image || 'https://placehold.jp/18/ebebeb/616161/400x300.png?text=No%20Image'} alt={item.name}/>
                                </a>
                                <div className="p-3">
                                    <h4 style={{minHeight: '40px'}}><a href={item.link}>{item.name}</a></h4>
                                    {/*<p>{item.short_description}</p>*/}
                                    <div className="text-secondary mt-1 font-s-13">
                                        {__('in')} {item.categories.map(category => category.name).join(', ')}
                                    </div>
                                    <div className="d-flex align-items-center mt-1 font-s-13">
                                        {item.tags.map(tag => <span className="badge text-bg-light font-w-400 me-1">{tag.name}</span>)}
                                    </div>
                                    <div className="d-flex align-items-center mt-1 gap-2 mt-3">
                                        {/*<div>*/}
                                        {/*    <div className={`font-s-14 font-w-400 ${item.on_sale ? 'text-decoration-line-through text-secondary' : ''}`} dangerouslySetInnerHTML={{__html: item.wc_regular_price}}/>*/}
                                        {/*    {item.on_sale && <div className="text-success font-s-14 font-w-400" dangerouslySetInnerHTML={{__html: item.wc_sale_price}}/>}*/}
                                        {/*</div>*/}
                                        <div className="d-flex align-items-center ms-auto gap-2 w-100">
                                            {/*<a href={item.checkout_link} className="btn btn-dark btn-sm"><i className="far fa-shopping-cart"></i> {__('Buy')}</a>*/}
                                            <a href={item.link} className="btn btn-dark btn-sm w-100 rounded-3">{__('Show Details')}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>) : !productsLoading && <div className="col-12 text-center">{__('No products found')}</div>}
                    </div>
                </div>
            </div>
        </>
    )
}